import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { useKeptWhileReloading } from "./use-kept-while-reloading";

import type { KeptState } from "./use-kept-while-reloading";

interface SentMomentCounts {
  sent: number;
  active: number;
}

/** Counted again when `refreshKey` changes, keeping the last counts meanwhile. */
export function useSentMomentCounts(refreshKey: number): KeptState<SentMomentCounts> {
  const counts = useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const countSent = () =>
        supabase
          .from("moments_sent")
          .select("id", { count: "exact", head: true })
          .eq("account_id", account_id);

      const [sent, active] = await Promise.all([countSent(), countSent().eq("status", "active")]);
      if (sent.error) throw sent.error;
      if (active.error) throw active.error;

      return { sent: sent.count ?? 0, active: active.count ?? 0 };
    },
    [refreshKey],
  );

  return useKeptWhileReloading(counts);
}
